import React from 'react';
import { useStore } from 'effector-react';
import { SceneType } from '@types';
import { $loadedId, $loadedScene } from '@stores/loadedStore';
import { useTabMain } from '@hooks/paramsHooks';
import { SidebarTagLine } from '@modules/tagLine/SidebarTagLine/SidebarTagLine';
import { SidebarCompass } from '@modules/compass';
import { SidebarCompare } from '@modules/compare/SidebarCompare';
import SidebarComponentLayer from '../componentLayer/SidebarComponentLayer';
import SidebarSetting from './SidebarSetting';
import SidebarView from './SidebarView';
import SidebarMask from './SidebarMask';
import SidebarNotSupport from './components/SidebarNotSupport';
import SidebarHotspot from '../hotspot/SidebarHotspot';
import { SidebarSceneSandTable } from './SidebarSceneSandTable';
import { SidebarEffect } from '../effect/SidebarEffect';
import { SidebarAutoRotate } from '../autoRotate/SidebarAutoRotate';
import { SidebarMusic } from './SidebarMusic';
import { SidebarSubtitle } from '../subtitle/SidebarSubtitle';

function TypeOnly({
  availableTypes,
  placeholder,
  children,
}: {
  availableTypes: SceneType[];
  placeholder: string;
  children: JSX.Element;
}) {
  const scene = useStore($loadedScene);
  if (!scene) return null;
  if (!availableTypes.includes(scene.type)) {
    return <SidebarNotSupport>{placeholder}</SidebarNotSupport>;
  }
  return children;
}

function Sidebar() {
  const loadedId = useStore($loadedId);
  const tab = useTabMain();
  const scene = useStore($loadedScene);
  const renderOnSceneLoaded = () => {
    return (
      <>
        {tab === 'view' && <SidebarView />}
        {tab === 'hotspot' && <SidebarHotspot />}
        {tab === 'component' && <SidebarComponentLayer />}
        {tab === 'music' && <SidebarMusic />}
        {tab === 'mask' && (
          <TypeOnly
            availableTypes={[SceneType.pano, SceneType.panoVideo]}
            placeholder="高清矩阵暂不支持设置遮罩"
          >
            <SidebarMask />
          </TypeOnly>
        )}
        {tab === 'sandTable' && <SidebarSceneSandTable />}
        {tab === 'effect' && (
          <TypeOnly
            availableTypes={[SceneType.pano, SceneType.panoVideo]}
            placeholder="高清矩阵暂不支持添加特效"
          >
            <SidebarEffect />
          </TypeOnly>
        )}
        {tab === 'rotate' && <SidebarAutoRotate />}
        {tab === 'subtitle' && <SidebarSubtitle />}
        {tab === 'tagLine' && (
          <TypeOnly
            availableTypes={[SceneType.pano, SceneType.matrix]}
            placeholder="全景视频暂不支持添加标尺标注"
          >
            <SidebarTagLine />
          </TypeOnly>
        )}
        {tab === 'compass' && (
          <TypeOnly
            availableTypes={[SceneType.pano]}
            placeholder={`${
              scene?.type === SceneType.matrix ? '高清矩阵' : '全景视频'
            }暂不支持添加指北针`}
          >
            <SidebarCompass />
          </TypeOnly>
        )}
        {tab === 'compare' && (
          <TypeOnly
            availableTypes={[SceneType.pano]}
            placeholder="全景视频、高清矩阵暂不支持添加场景对比"
          >
            <SidebarCompare />
          </TypeOnly>
        )}
      </>
    );
  };

  return (
    <div className="relative w-250 flex-shrink-0 bg-black">
      {tab === 'basic' && <SidebarSetting />}
      {!!loadedId && renderOnSceneLoaded()}
    </div>
  );
}

export default Sidebar;
